


















































































































import { defineComponent } from 'vue';
import { JSONView } from 'vue-json-component';
import { f7 } from 'framework7-vue';

import deployJSON from 'src/../deploy.json';
import config from 'src/app.config.js';
import bus from 'src/bus';
import { appStoreMapper } from '@/store/appstore';
import Storage from '@/storage';
import { LOCALSTORAGE_RECORDSESSION } from '@/misc/const';
import { showErrorDialog } from '@/misc';
import { AppData } from '@/types';

export default defineComponent({
  name: 'Debug',
  components: { JSONView },
  data: () => ({
    config,
    openAttempts: 0,
    recordSessionState: 0,
    popupVisible: false,
    configVisible: false,
    jsonVisible: false,
    storageVisible: false,
  }),
  mounted() {
    bus.$on('showDebugPopup', this.showDebugPopup);

    this.recordSessionState = Storage.getSync(LOCALSTORAGE_RECORDSESSION);
  },
  destroyed() {
    bus.$off('showDebugPopup', this.showDebugPopup);
  },
  computed: {
    userAgent(): string {
      return window.navigator.userAgent;
    },
    platform(): 'android' | 'ios' {
      return this.$theme.ios ? 'ios' : 'android';
    },
    appDataJSON(): any {
      return this.appData ? JSON.parse(JSON.stringify(this.appData)) : {};
    },
    storageJSON(): any {
      return window.storage;
    },
    appName(): string {
      return typeof deployJSON.name === 'string'
        ? deployJSON.name
        : deployJSON.name[this.platform];
    },
    appVersion(): string {
      return typeof deployJSON.version === 'string'
        ? deployJSON.version
        : deployJSON.version[this.platform];
    },
    ...appStoreMapper.mapState(['appData', 'pushToken', 'verbose']),
  },
  methods: {
    showDebugPopup() {
      if (
        window.location.host.includes('getmeback-stage.ru') ||
        window.location.host.includes('static.wellsales.ru') ||
        window.location.host.includes('static.gmb-dev.ru') ||
        window.location.host.includes(':8080')
      ) {
        this.$f7.popup.open('.popup-debug');
      } else {
        if (this.openAttempts < 10) {
          this.openAttempts++;
        } else {
          this.$f7.popup.open('.popup-debug');
        }
      }
    },
    toggleSessionRecord() {
      this.recordSessionState = this.recordSessionState != 1 ? 1 : 0;

      Storage.setSync(LOCALSTORAGE_RECORDSESSION, this.recordSessionState);

      bus.$emit('recordSession', this.recordSessionState);

      if (!this.recordSessionState) {
        this.$f7?.dialog.alert(
          'Записи сессий будут прекращены после перезагрузки приложения. Чтобы снова записывать отладночные сессии, необходимо повторно включить соответствующую опцию',
          'Выключение записи сессий',
        );
      }
    },
    onPopupClosed() {
      this.popupVisible = false;
      this.jsonVisible = false;
      this.configVisible = false;
      this.storageVisible = false;
    },
    onPopupOpen() {
      this.popupVisible = true;
    },
    toggleVerbose() {
      this.setVerbose(!this.verbose);
    },
    pushAppData() {
      const dialog = f7.dialog.prompt('appData', async (value: string) => {
        f7.preloader.show();

        try {
          const mock = JSON.parse(value) as AppData;
          if (mock.timestamp) delete mock.timestamp;
          await this.getAppData({ bus, mock });
          f7.panel.close();
        } catch (error) {
          showErrorDialog({ error });
        } finally {
          f7.preloader.hide();
        }
      });

      dialog && dialog.open();
    },
    pushStorage() {
      const dialog = f7.dialog.prompt('localStorage', async (value: string) => {
        f7.preloader.show();

        try {
          const storage = JSON.parse(value) as { [key: string]: any };
          Storage.setSync(null, storage);
          f7.panel.close();
        } catch (error) {
          showErrorDialog({ error });
        } finally {
          f7.preloader.hide();
        }
      });

      dialog && dialog.open();
    },
    async copyAppDataToClipboard() {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(JSON.stringify(this.appDataJSON));
        }
      } catch (e) {
        showErrorDialog(e);
      }
    },
    async copyStorageToClipboard() {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(JSON.stringify(this.storageJSON));
        }
      } catch (e) {
        showErrorDialog(e);
      }
    },
    showConfig() {
      this.configVisible = true;
    },
    showJSON() {
      this.jsonVisible = true;
    },
    showStorage() {
      this.storageVisible = true;
    },
    ...appStoreMapper.mapActions(['getAppData']),
    ...appStoreMapper.mapMutations(['setVerbose']),
  },
});
